<template>
  <div class="relative">
    <b-modal
      id="editModal"
      size="xl"
      centered
      modal-content-classes="cust-modal-ht"
      hide-footer
      scrollable
      hide-header
      class="overflow-y-hidden"
    >
      <div class="text-black p-8">
        <div>
          <div class="flex justify-between items-center pb-4">
            <p class="text-2xl font-semibold">ISBA Test</p>
            <img
              src="../../../assets/images/cross.png"
              class="h-8 w-8 cursor-pointer"
              alt="cross"
              v-b-modal.editModal
            />
          </div>
          <div class="pt-4" v-for="(item, index) in 4" :key="index">
            <p class="clr777 font-normal text-lg">Question 1</p>
            <p class="font-medium text-2xl text-black pt-3">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam?
            </p>

            <b-form-group v-slot="{ ariaDescribedby }" class="pt-6">
              <div class="flex items-center">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="A"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black">Option A</span>
                </b-form-radio>
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="B"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option B</span
                  ></b-form-radio
                >
              </div>
              <div class="flex pt-3">
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="C"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option C</span
                  ></b-form-radio
                >
                <b-form-radio
                  v-model="selected"
                  :aria-describedby="ariaDescribedby"
                  name="some-radios"
                  value="D"
                  class="w-1/2"
                >
                  <span class="font-medium text-2xl text-black"
                    >Option D</span
                  ></b-form-radio
                >
              </div>
            </b-form-group>
          </div>
        </div>
      </div>
    </b-modal>
    <swiper class="swiper" :options="swiperOptions">
      <!-- v-for="(item, index) in 6" :key="index" -->
      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative md:hidden lg:hidden block lg:top-0 md:top-0 top-36"
          >
            <img
              src="../../../assets/images/Product/ProductBanner.png"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="lg:w-5/6 md:w-5/6 w-full w-full ml-auto lg:pt-0 md:pt-0 pt-24 lg:px-0 md:px-0 px-6"
            >
              <p
                class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Shop
              </p>
              <p
                class="lg:text-2xl md:text-2xl sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                Buy products for stress free caregiving
                 <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> 
                <span
                  class="underline text-4f0a4b min-hidden font-semibold"
                  @click="handleClick('ecommerce')"
                  >Buy Now</span
                >
              </p>
              <div class="flex pt-8">
                <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> 
                <a href="/ecommerce"
                  ><base-button
                    type="primary"
                    class="paddingidentifybtn btntext mob-hidden"
                    >Buy now</base-button
                  ></a
                >
              </div>
            </div>
          </div>
          <div class="w-1/2 relative">
            <img
              src="../../../assets/images/Product/ProductBanner.png"
              alt="cp bg"
              class="mob-hidden w-full relative h-95per bg-white"
            />
            <img
              src="../../../assets/images/hcp-swpr-3.svg"
              class="w-full absolute top6rem h-screen"
              alt=""
            /> 
          </div>
        </div>
      </swiper-slide> -->

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative md:hidden lg:hidden block lg:top-0 md:top-0 top-72"
          >
            <img
              src="../../../assets/images/subscribe_banner.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="lg:w-5/6 md:w-5/6 w-full w-full ml-auto lg:pt-0 md:pt-0 pt-24 lg:px-0 md:px-0 px-6"
            >
              <p
                class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Subscribe for support &amp; services
              </p>
              <p
                class="lg:text-2xl md:text-2xl sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                For regular ongoing support, you may want to subscribe to our
                bundled services for additional benefits.

                 <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> 
                <a href="/subscribe">
                  <span class="underline text-4f0a4b min-hidden font-semibold"
                    >Know More</span
                  >
                </a>
              </p>
              <div class="flex pt-8">
                 <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> 
                <a href="/subscribe"
                  ><base-button
                    type="primary"
                    class="paddingidentifybtn btntext mob-hidden"
                    >Know more</base-button
                  ></a
                >
              </div>
            </div>
          </div>
          <div class="w-1/2 relative pt-24">
            <img
              src="../../../assets/images/subscribe_banner.svg"
              alt="cp bg"
              class="mob-hidden w-full relative h-80per bg-white"
            />
             <img
              src="../../../assets/images/hcp-swpr-3.svg"
              class="w-full absolute top6rem h-screen"
              alt=""
            /> 
          </div>
        </div>
      </swiper-slide> -->

      <!-- <swiper-slide class="sm-h600">
        <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="lg:flex md:flex pt-24">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          />
          <div
            class="lg:w-1/2 md:w-1/2 w-full relative md:hidden lg:hidden block lg:top-0 md:top-0 top-64"
          >
            <img
              src="../../../assets/images/Product/Banner.svg"
              class="w-full absolute md:hidden lg:hidden block"
              alt="swiper-img"
            />
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full lg:p-12 md:p-12 my-auto">
            <div
              class="lg:w-5/6 md:w-5/6 w-full w-full ml-auto lg:pt-0 md:pt-0 lg:px-0 md:px-0 px-6"
            >
              <p
                class="font-semibold fsize35 sm-fsize24 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full w-full"
              >
                Solutions to ease your caregiving journey
              </p>
              <p
                class="lg:text-xl md:text-xl sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
              >
                At Caregiver Saathi, we recognise the challenges you face as a
                caregiver everyday. Long term caregiving, care for the elderly
                and chronically ill can be complex and demanding.
                <br />
                We offer you solutions that can help you navigate your
                caregiving journey better, ensuring your well-being and the
                welfare of your loved one.
                 <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> 
                <a href="/services">
                  <span class="underline text-4f0a4b min-hidden font-semibold"
                    >Know More</span
                  >
                </a>
              </p>
              <div class="flex pt-8">
                 <a
                  target="_blank"
                  class="hover:text-white"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSd9jGpYFrlJYPl3vlQxYrEBrDYVa271eICJ2434YlSISBpxwA/viewform"
                >
                </a> 
                <a href="/services"
                  ><base-button
                    type="primary"
                    class="paddingidentifybtn btntext mob-hidden"
                    >Know More</base-button
                  ></a
                >
              </div>
            </div>
          </div>
          <div class="w-1/2 relative pt-24">
            <img
              src="../../../assets/images/Product/Banner.svg"
              alt="cp bg"
              class="mob-hidden w-full relative h-80per bg-white"
            />
            <img
              src="../../../assets/images/hcp-swpr-3.svg"
              class="w-full absolute top6rem h-screen"
              alt=""
            /> 
          </div>
        </div>
      </swiper-slide> -->

      <swiper-slide
        class="sm-h600"
        v-for="item in get_AllBanner"
        :key="item.objectId"
        @click="toggleDetails(true, item)"
      >
        <!-- <div class="absolute bg-design-s3tt mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3tt.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3rt mob-hidden">
          <img src="../../../assets/images/bg-des/s3rlt.svg" alt="bg-polygon" />
        </div>
        <div class="absolute bg-design1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/bgd1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design3 mob-hidden">
          <img
            src="../../../assets/images/Ellipse 12.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div>
        <div class="absolute bg-design-s3e1 mob-hidden">
          <img
            src="../../../assets/images/bg-des/s3e1.svg"
            alt="bg-polygon"
            class="h-full"
          />
        </div> -->
        <div class="h-95per">
          <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="absolute h-640px right-0"
          />
        </div>

        <div
          class="lg:flex md:flex items-center lg:px-20 md:px-20 px-5 lg:mt-28 md:mt-28 mt-28"
        >
          <!-- <img
            src="../../../assets/images/cp-bg.png"
            alt="cp bg"
            class="min-hidden w-80per absolute top-0 right-0 line-bgh-525px z-index--1"
          /> -->
          <div
            class="lg:w-1/2 md:w-1/2 w-full md:hidden lg:hidden block lg:top-0 md:top-0 top-72"
          >
            <img
              class="custborderradius m-auto"
              :src="image(item.image)"
              :alt="item.heading"
            />
          </div>
          <div
            class="lg:w-1/2 md:w-1/2 w-full lg:pr-8 md:pr-8 lg:pt-0 md:pt-0 pt-5"
          >
            <div class="">
              <p
                class="font-semibold fsize35 sm-fsize20 line-h60 letter-s016px text-black leading-snug lg:w-full md:w-full"
              >
                <!-- Solutions to ease your caregiving journey -->
                {{ item.heading }}
              </p>
              <p
                class="custfsize20px sm-fsize14 font-normal lg:pt-6 md:pt-6 pt-3 lh40px sm-lh20"
                v-html="item.discription"
              ></p>
              <div class="flex lg:pt-8 md:pt-8 mob-hidden">
                <base-button
                  type="primary"
                  class="btntext"
                  @click="handleClick(item.redirectTo)"
                  >{{ item.buttonName }}</base-button
                >
              </div>
            </div>
          </div>
          <div class="lg:w-1/2 md:w-1/2 w-full relative mob-hidden">
            <img
              class="custborderradius m-auto h-325"
              :src="image(item.image)"
              :alt="item.heading"
            />
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev shopswiper" slot="button-prev"></div>
      <div class="swiper-button-next shopswiper" slot="button-next"></div>
      <div class="swiper-pagination cust-posi bott-0" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        // autoplay: {
        //   delay: 12000,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      editModal: false,
    };
  },
  // methods: {
  //   handleClick(name) {
  //     this.$router.push({ name: name });
  //   },
  //   handleScroll() {
  //     const el = document.getElementById("SolutionDiv");
  //     el.scrollIntoView({ behavior: "smooth", block: "center" });
  //   },
  // },
  methods: {
    handleClick(name) {
      if (name === "product-services") {
        const communityMembership = document.getElementById(
          "communityMembership"
        );
        communityMembership.scrollIntoView({
          behavior: "smooth",
        });
      } else {
        this.$router.push({ name: name });
      }
    },

    async function() {
      let payload = "testing";
      await this.$store.dispatch("services/getbanner");
      // console.log(this.get_AllBanner);
    },
    image(x) {
      return `${this.$imageURL}/${x}`;
    },
    toggleDetails(val = false, item = {}) {
      this.isDetailsActive = val;
      this.selectedExclusive = item;
    },
  },
  computed: {
    ...mapState("services", { get_AllBanner: "get_AllBanner" }),
  },
  mounted() {
    this.function();
  },
};
</script>
<style scoped>
.h-80per {
  height: 80%;
}
@media (min-width: 1024px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.9);
    filter: hue-rotate(40deg);
  }

  .swiper-button-next {
    right: 30px !important;
  }

  .swiper-button-prev {
    left: 30px !important;
  }
  .bott-0 {
    bottom: 0%;
  }
}
@media (max-width: 640px) {
  .swiper-button-next,
  .swiper-button-prev {
    transform: scale(0.5);
    filter: hue-rotate(40deg);
  }
}
</style>
